// extracted by mini-css-extract-plugin
export var address = "Layout-module--address--5796c";
export var contact = "Layout-module--contact--53ca9";
export var contactContainer = "Layout-module--contact-container--f15d5";
export var copy = "Layout-module--copy--fa982";
export var footer = "Layout-module--footer--ef4f9";
export var social = "Layout-module--social--acbeb";
export var socialContainer = "Layout-module--social-container--1fc3b";